import Rellax from 'rellax'
new Rellax('.rellax')



// WEBPACK FOOTER //
// ./src/scripts/parallax.js